import React, { Component } from "react";
import Spinner from "components/elements/spinner";

export default (ChildComponent) => {
  class ComposedComponent extends Component {
    state = {
      showSpinner: false,
    };

    onProcessBegin = () => {
      // console.log(ChildComponent.name + "_PROCESS BEGUN");
      this.setState({ showSpinner: true });
    };

    onProcessEnd = () => {
      // console.log(ChildComponent.name + "_PROCESS END");
      this.setState({ showSpinner: false });
    };

    renderSpinner = () => {
      return this.state.showSpinner ? <Spinner></Spinner> : null;
      //   return <Spinner></Spinner>;
    };

    render() {
      return (
        <ChildComponent
          {...this.props}
          onProcessBegin={this.onProcessBegin}
          onProcessEnd={(res) => this.onProcessEnd(res)}
          spinner={this.renderSpinner()}
        />
      );
    }
  }
  // function mapStateToProps(state) {
  //   return { application: state.auth };
  // }
  return ComposedComponent;
};
